export const MUX_BUCKETS = {
  LANDING_PAGE_BUILDER: 'LPB',
};
